<template>
  <div v-if="aiEnabled" class="ai-actions">
    <button class="crazy-button-design" @click="showAiSnappingDialog"><fp-icon symbol="sparkles" size="20" /> OLYO AI</button>
    <button class="crazy-button-design" @click="showAiGallery"><fp-icon symbol="image-gallery" size="20" /> AI Gallery</button>
  </div>
</template>
<script setup>
import FpIcon from "@/components/FpIcon.vue";
import store from "@/store";
import {computed, defineProps} from "vue";

const aiEnabled = computed(() => store.getters['aIAgent/aiEnabled']);


const props = defineProps({
  snapType: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'gallery'].includes(value),
  },
  currentImage: {
    type: String,
    default: null,
  }
});

const showAiSnappingDialog = () => {
  console.log({
    currentImage: props.currentImage
  })
  if(props.snapType === 'default'){
    store.commit('aIAgent/showAiSnappingDialog', true);
    store.commit('aIAgent/aiSnapshotProcess', true);
  } else if(props.snapType === 'gallery' && props.currentImage){
    store.commit('aIAgent/showAiReady', true);
    setTimeout(() => {
      store.commit('aIAgent/showAiReady', false)
      store.commit('aIAgent/currentSnapshot', props.currentImage);
      store.commit('aIAgent/showAiDialog', true);
    }, 1000)
  }
};

const showAiGallery = () => {
  store.commit('aIAgent/showAiImagesLibrary', true);
};
</script>
<style lang="scss" scoped>
.ai-actions {
  position: absolute;
  right: 60px;
  top: 50%;
  z-index: 10000;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  flex-flow: column;
}

.crazy-button-design {
  accent-color: auto;
  align-content: normal;
  align-items: center;
  align-self: auto;
  alignment-baseline: auto;
  anchor-name: none;
  anchor-scope: none;
  animation-composition: replace;
  animation-delay: 0s;
  animation-direction: normal;
  animation-duration: 0s;
  animation-fill-mode: none;
  animation-iteration-count: 1;
  animation-name: none;
  animation-play-state: running;
  animation-range-end: normal;
  animation-range-start: normal;
  animation-timeline: auto;
  animation-timing-function: ease;
  app-region: none;
  appearance: none;
  backdrop-filter: blur(16px);
  backface-visibility: visible;
  background-attachment: scroll;
  background-blend-mode: normal;
  background-clip: border-box;
  background-color: oklab(0.21 -0.00316127 -0.0338527 / 0.95);
  background-image: none;
  background-origin: padding-box;
  background-position: 0% 0%;
  background-repeat: repeat;
  background-size: auto;
  baseline-shift: 0px;
  baseline-source: auto;
  block-size: 38px;
  border-block-end-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-block-end-style: solid;
  border-block-end-width: 1px;
  border-block-start-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-block-start-style: solid;
  border-block-start-width: 1px;
  border-bottom-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-collapse: separate;
  border-end-end-radius: 8px;
  border-end-start-radius: 8px;
  border-image-outset: 0;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-inline-end-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-inline-end-style: solid;
  border-inline-end-width: 1px;
  border-inline-start-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-inline-start-style: solid;
  border-inline-start-width: 1px;
  border-left-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-right-style: solid;
  border-right-width: 1px;
  border-start-end-radius: 8px;
  border-start-start-radius: 8px;
  border-top-color: oklab(0.715 -0.116822 -0.0824726 / 0.3);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-top-style: solid;
  border-top-width: 1px;
  bottom: auto;
  box-decoration-break: slice;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, oklab(0.715 -0.116822 -0.0824726 / 0.2) 0px 20px 25px -5px, oklab(0.715 -0.116822 -0.0824726 / 0.2) 0px 8px 10px -6px;
  box-sizing: border-box;
  break-after: auto;
  break-before: auto;
  break-inside: auto;
  buffered-rendering: auto;
  caption-side: top;
  caret-animation: auto;
  caret-color: rgb(255, 255, 255);
  clear: none;
  clip: auto;
  clip-path: none;
  clip-rule: nonzero;
  color: rgb(255, 255, 255);
  color-interpolation: srgb;
  color-interpolation-filters: linearrgb;
  color-rendering: auto;
  column-count: auto;
  column-gap: 4px;
  column-rule-color: rgb(255, 255, 255);
  column-rule-style: none;
  column-rule-width: 0px;
  column-span: none;
  column-width: auto;
  contain-intrinsic-block-size: none;
  contain-intrinsic-height: none;
  contain-intrinsic-inline-size: none;
  contain-intrinsic-size: none;
  contain-intrinsic-width: none;
  container-name: none;
  container-type: normal;
  content: normal;
  corner-bottom-left-shape: round;
  corner-bottom-right-shape: round;
  corner-end-end-shape: round;
  corner-end-start-shape: round;
  corner-start-end-shape: round;
  corner-start-start-shape: round;
  corner-top-left-shape: round;
  corner-top-right-shape: round;
  cx: 0;
  cy: 0;
  d: none;
  direction: rtl;
  display: inline-flex;
  gap: 10px;
  dominant-baseline: auto;
  dynamic-range-limit: no-limit;
  empty-cells: show;
  field-sizing: fixed;
  fill: rgb(0, 0, 0);
  fill-opacity: 1;
  fill-rule: nonzero;
  filter: none;
  flex-basis: auto;
  flex-direction: row;
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: nowrap;
  float: none;
  flood-color: rgb(0, 0, 0);
  flood-opacity: 1;
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-kerning: auto;
  font-language-override: normal;
  font-optical-sizing: auto;
  font-palette: normal;
  font-size: 12px;
  font-size-adjust: none;
  font-stretch: 100%;
  font-style: normal;
  font-synthesis-small-caps: none;
  font-synthesis-style: none;
  font-synthesis-weight: none;
  font-variant: normal;
  font-variant-alternates: normal;
  font-variant-caps: normal;
  font-variant-east-asian: normal;
  font-variant-emoji: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  font-weight: 500;
  grid-auto-columns: auto;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-column-end: auto;
  grid-column-start: auto;
  grid-row-end: auto;
  grid-row-start: auto;
  grid-template-areas: none;
  grid-template-columns: none;
  grid-template-rows: none;
  height: 38px;
  hyphenate-character: auto;
  hyphenate-limit-chars: auto;
  hyphens: manual;
  image-orientation: from-image;
  image-rendering: auto;
  initial-letter: normal;
  inline-size: 119.883px;
  inset-block-end: auto;
  inset-block-start: auto;
  inset-inline-end: auto;
  inset-inline-start: auto;
  interactivity: auto;
  interest-delay-end: normal;
  interest-delay-start: normal;
  interpolate-size: numeric-only;
  isolation: auto;
  justify-content: center;
  justify-items: normal;
  justify-self: auto;
  left: auto;
  letter-spacing: normal;
  lighting-color: rgb(255, 255, 255);
  line-break: auto;
  line-height: 16px;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: disc;
  margin-block-end: 0px;
  margin-block-start: 0px;
  margin-bottom: 0px;
  margin-inline-end: 0px;
  margin-inline-start: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  marker-end: none;
  marker-mid: none;
  marker-start: none;
  mask-clip: border-box;
  mask-composite: add;
  mask-image: none;
  mask-mode: match-source;
  mask-origin: border-box;
  mask-position: 0% 0%;
  mask-repeat: repeat;
  mask-size: auto;
  mask-type: luminance;
  math-depth: 0;
  math-shift: normal;
  math-style: normal;
  max-block-size: none;
  max-height: none;
  max-inline-size: none;
  max-width: none;
  min-block-size: 0px;
  min-height: 0px;
  min-inline-size: 0px;
  min-width: 0px;
  mix-blend-mode: normal;
  object-fit: fill;
  object-position: 50% 50%;
  object-view-box: none;
  offset-anchor: auto;
  offset-distance: 0px;
  offset-path: none;
  offset-position: normal;
  offset-rotate: auto 0deg;
  opacity: 1;
  order: 0;
  orphans: 2;
  outline-color: oklab(0.708 0 0 / 0.5);
  outline-offset: 0px;
  outline-style: none;
  outline-width: 0px;
  overflow-anchor: auto;
  overflow-block: hidden;
  overflow-clip-margin: 0px;
  overflow-inline: hidden;
  overflow-wrap: normal;
  overflow-x: hidden;
  overflow-y: hidden;
  overlay: none;
  overscroll-behavior-block: auto;
  overscroll-behavior-inline: auto;
  padding-block-end: 8px;
  padding-block-start: 8px;
  padding-bottom: 8px;
  padding-inline-end: 20px;
  padding-inline-start: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  paint-order: normal;
  perspective: none;
  perspective-origin: 59.9375px 19px;
  pointer-events: auto;
  position: static;
  position-anchor: auto;
  position-area: none;
  position-try-fallbacks: none;
  position-try-order: normal;
  position-visibility: anchors-visible;
  print-color-adjust: economy;
  r: 0px;
  reading-flow: normal;
  reading-order: 0;
  resize: none;
  right: auto;
  rotate: none;
  row-gap: 4px;
  ruby-align: space-around;
  ruby-position: over;
  rx: auto;
  ry: auto;
  scale: none;
  scroll-behavior: auto;
  scroll-initial-target: none;
  scroll-margin-block-end: 0px;
  scroll-margin-block-start: 0px;
  scroll-margin-inline-end: 0px;
  scroll-margin-inline-start: 0px;
  scroll-marker-group: none;
  scroll-padding-block-end: auto;
  scroll-padding-block-start: auto;
  scroll-padding-inline-end: auto;
  scroll-padding-inline-start: auto;
  scroll-target-group: none;
  scroll-timeline-axis: block;
  scroll-timeline-name: none;
  scrollbar-color: auto;
  scrollbar-gutter: auto;
  scrollbar-width: auto;
  shape-image-threshold: 0;
  shape-margin: 0px;
  shape-outside: none;
  shape-rendering: auto;
  speak: normal;
  stop-color: rgb(0, 0, 0);
  stop-opacity: 1;
  stroke: none;
  stroke-dasharray: none;
  stroke-dashoffset: 0px;
  stroke-linecap: butt;
  stroke-linejoin: miter;
  stroke-miterlimit: 4;
  stroke-opacity: 1;
  stroke-width: 1px;
  tab-size: 4;
  table-layout: auto;
  text-align: start;
  text-align-last: auto;
  text-anchor: start;
  text-autospace: no-autospace;
  text-box-edge: auto;
  text-box-trim: none;
  text-decoration: none;
  text-decoration-color: rgb(255, 255, 255);
  text-decoration-line: none;
  text-decoration-skip-ink: auto;
  text-decoration-style: solid;
  text-emphasis-color: rgb(255, 255, 255);
  text-emphasis-position: over;
  text-emphasis-style: none;
  text-indent: 0px;
  text-overflow: clip;
  text-rendering: auto;
  text-shadow: none;
  text-size-adjust: 100%;
  text-spacing-trim: normal;
  text-transform: none;
  text-underline-position: auto;
  text-wrap-mode: nowrap;
  text-wrap-style: auto;
  timeline-scope: none;
  top: auto;
  touch-action: auto;
  transform: none;
  transform-origin: 59.9414px 19px;
  transform-style: flat;
  transition-behavior: normal;
  transition-delay: 0s;
  transition-duration: 0.15s;
  transition-property: color, box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  translate: none;
  unicode-bidi: normal;
  user-select: auto;
  vector-effect: none;
  vertical-align: baseline;
  view-timeline-axis: block;
  view-timeline-inset: auto;
  view-timeline-name: none;
  view-transition-class: none;
  view-transition-group: normal;
  view-transition-name: none;
  visibility: visible;
  white-space-collapse: collapse;
  widows: 2;
  width: 119.883px;
  will-change: auto;
  word-break: normal;
  word-spacing: 0px;
  writing-mode: horizontal-tb;
  z-index: auto;
  zoom: 1;
  cursor: pointer;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.1);
  }

  svg {
    stroke: var(--primary);
    fill: var(--primary);
  }
}

.rtl {
  .ai-actions {
    right: auto;
    left: 60px;
  }
}

</style>